import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/construction-bro-orange.png")